<div class="card" style="overflow: auto;">
    <div class="card-header" style="overflow: auto;">
        Reduction Of Manpower
    </div>
    <div class="card-body" style="overflow: auto;">
        <div class="row m-1">
            <div class="col-md-8 px-1">
                <label class="Label">Site</label>
                <ng-select name="site" [items]="SiteLoad" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="SiteId" (change)="onSelectChange('Site'); ComboLoad('Designation')" disabled>
                    <ng-option *ngFor="let segment of SiteLoad" [value]="segment.SiteMasterID">
                        {{ segment.SiteName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-6 px-1">
                <label class="Label">Designation</label>
                <ng-select name="designation" [items]="DesignationLoad" bindLabel="DesignationName"
                    [(ngModel)]="DesignationId" (change)=" onSelectChange('Designation'); ComboLoad('Duty')"
                    bindValue="DesignationMasterID">
                    <ng-option *ngFor="let segment of DesignationLoad" [value]="segment.DesignationMasterID">
                        {{ segment.DesignationName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-3 px-1">
                <label class="Label">Duty</label>
                <ng-select name="dutyname" [items]="DutyLoad" [(ngModel)]="DutyId" (change)="onSelectChange('Duty')"
                    bindLabel="DutyName" bindValue="DutyMasterID">
                    <ng-option *ngFor="let segment of DutyLoad" [value]="segment.DutyMasterID">
                        {{ segment.DutyName }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-md-3 px-1">
                <label class="Label">Shift</label>
                <ng-select name="Shift" [items]="Shift" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                    [(ngModel)]="ShiftID" (change)="onSelectChange('Shift')">
                    <ng-option *ngFor="let segment of Shift" [value]="segment.ShiftMasterID">
                        {{ segment.ShiftTitle }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-md-2 px-1">
                <label class="Label">Work Order No.</label>
                <input name="workorderno" [(ngModel)]="WorkOrderNumber" type="text" class="form-control" />
            </div>
            <div class="col-md-3 px-1"><br>
                <!-- <button class="btn btn-sm btn-primary" name="add" (click)="Load()"><i class="bi bi-download"></i> Load
                </button> -->
                <button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled" (click)="Load()">
                    <i class="bi bi-download" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Load':'Loading...'}}
                </button>

            </div>
        </div>
        <!-- <div class="card border-radius-0 mt-1 p-0">
            <div class="card-body p-1" style="overflow: auto;"> -->
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead>
                <tr>
                    <th scope="col" style="width: 3px;">#</th>
                    <th style="display: none;">Ref ESS ShiftWiseManpowerDetailsId</th>
                    <th scope="col" style="display: none;">Designation ID</th>
                    <th scope="col">Entry No </th>
                    <th scope="col">Addition Date</th>
                    <th scope="col">Designation </th>
                    <th scope="col" style="display: none;">Duty ID</th>
                    <th scope="col">Duty </th>
                    <th scope="col" style=" display: none;">Shift ID</th>
                    <th scope="col">Shift</th>
                    <th scope="col">WO No.</th>
                    <th scope="col">WO Dt.</th>
                    <th scope="col" style="width: 5px;">Balance </th>
                    <th scope="col">Reduction Count</th>
                    <th scope="col" style="width: 7px;">Reduction Date</th>
                    <th scope="col">Remarks</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let shift of WorkOrderTable; let i = index">
                    <th scope="row" style="width: 3px;">{{ i + 1 }}</th>
                    <td style="display: none;">{{shift.RefESS_ShiftWiseManpowerDetailsId}}</td>
                    <td style="display: none;">{{ shift.DesignationId }}</td>
                    <td>{{shift.EntryNo}}</td>
                    <td>{{shift.AdditionDate}}</td>
                    <td>{{shift.DesignationName}}</td>
                    <td style="display: none;">{{shift.DutyId}}</td>
                    <td>{{shift.DutyName}}</td>
                    <td style="display: none;">{{shift.ShiftId}}</td>
                    <td>{{shift.ShiftTitle}}</td>
                    <td>{{shift.WONo}}</td>
                    <td>{{shift.WODate}}</td>
                    <td class="right-align" style="width: 5px;">
                        <span class="no-of-person">{{shift.Balance}}
                        </span>
                    </td>
                    <td>
                        <input name="radius" class="form-control" [(ngModel)]="shift.NoOfPerson" type="number"
                            style="text-align: right; " (keypress)="onKeyPress($event)" min="0" />
                    </td>
                    <td style="width: 7px;">
                        <div class="input-group" style="height: auto;">
                            <input class="form-control" name="WorkOrderDate" placeholder="DD/MMM/YYYY" ngbDatepicker
                                #d1="ngbDatepicker" [minDate]="{ year:1930, month: 12, day: 31 }"
                                [(ngModel)]="shift.FromDate" [maxDate]="{ year: 2124, month: 12, day: 31 }" required
                                style="height: auto; font-size: small; padding: 0.2rem 0.4rem;" readonly />
                            <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d1.toggle()"
                                type="button" style="height: auto; padding: 0.25rem 0.4rem; font-size: small;"></button>
                        </div>
                    </td>
                    <td>
                        <input name="radius" class="form-control" [(ngModel)]="shift.Remarks" type="text"
                            style="text-align: right; " />
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- </div>
        </div> -->
    </div>
    <div class="card-footer" style="overflow: auto;">
        <div class="row">
            <div class="col">

                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled" (click)="Cancel()">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>

                &nbsp; <button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled" (click)="Ok()">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'OK':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>